import { Sparkles, ShieldCheck, BarChart3 } from "lucide-react";

const PILLARS = [
    {
        n: "01",
        title: "Agency Excellence",
        icon: Sparkles,
        body: "An external media department staffed by vetted, specialist leads — not a generalist account team. Every project shipped to studio standard.",
        accent: "Studio-grade craft",
    },
    {
        n: "02",
        title: "Reputation Engineering",
        icon: ShieldCheck,
        body: "Authority is a system, not an accident. We architect coverage, narrative, and search presence so your brand becomes the answer — not an option.",
        accent: "Authority by design",
    },
    {
        n: "03",
        title: "Measurable Impact",
        icon: BarChart3,
        body: "Vanity metrics retired. Every engagement is tracked against the AMEC integrated framework with hard ROI deliverables and quarterly board-ready reporting.",
        accent: "ROI, audited.",
    },
];

export default function Pillars() {
    return (
        <section
            id="pillars"
            data-testid="pillars-section"
            className="relative py-28 md:py-36 bg-[#0a0a0c]"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16 reveal">
                    <div>
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#e6192b] mb-5">
                            ⎯⎯ §02 · Three Pillars
                        </div>
                        <h2 className="font-serif-display text-5xl md:text-6xl leading-[0.95] tracking-tight max-w-3xl">
                            How a modern{" "}
                            <span className="italic">media department</span>{" "}
                            should actually work.
                        </h2>
                    </div>
                    <p className="text-[#a0a0ab] max-w-sm text-sm leading-relaxed">
                        Three interlocking disciplines. One outcome:
                        compounding, defensible reputation capital.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 border border-[#26262a]">
                    {PILLARS.map(({ n, title, icon: Icon, body, accent }, i) => (
                        <div
                            key={n}
                            data-testid={`pillar-${i}`}
                            className={`relative editorial-card border-0 p-10 md:p-12 reveal ${
                                i < PILLARS.length - 1
                                    ? "md:border-r border-[#26262a]"
                                    : ""
                            } ${i > 0 ? "border-t md:border-t-0" : ""}`}
                            style={{ transitionDelay: `${i * 100}ms` }}
                        >
                            <div className="flex items-start justify-between mb-12">
                                <span className="font-serif-display italic text-5xl text-[#e6192b]">
                                    {n}
                                </span>
                                <Icon
                                    size={22}
                                    className="text-[#a0a0ab] mt-3"
                                    strokeWidth={1.2}
                                />
                            </div>
                            <h3 className="font-serif-display text-3xl md:text-4xl leading-tight mb-5">
                                {title}
                            </h3>
                            <p className="text-[#a0a0ab] leading-relaxed mb-8">
                                {body}
                            </p>
                            <div className="pt-5 border-t border-[#26262a] text-[11px] uppercase tracking-[0.22em] text-[#e6192b]">
                                ↳ {accent}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
